import React, {Component} from 'react';
import {Button, Modal} from "react-bootstrap";
import {LinkContainer} from "react-router-bootstrap";
import {API} from "aws-amplify";
export default class TagsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bsClass: 'modal-header modal-header-danger',
      modalTitle: 'Error',
      modalMessage: 'There aren\'t any tags available.',
      errorRedirect: '',
      showModal: false,
      blogCategories: [],
      blogTags: [],
      blogTagsCount: {}
    }
  }
  async componentDidMount(){
    try {
      const blogTags = await API.get("api", `/blog/tags`);
      const blogCategories = await API.get("api", `/blog/categories`);
      this.setState({
        blogTags: blogTags.blogTags,
        blogTagsCount: blogTags.blogTagsCount,
        blogCategories: blogCategories.blogCategories
      });
    } catch(e) {
      let errorMessage = 'There aren\'t any tags available.';
      if (e.message && e.message !== 'Network Error') {errorMessage = e.message;}
      if (e.response && e.response !== 'Network Error') {errorMessage = e.response.data.errorMessage;}
      this.setState({
        bsClass: 'modal-header modal-header-danger',
        modalTitle: 'Error',
        modalMessage: errorMessage,
        showModal: true
      });
    }
  }
  renderCategories() {
    if (this.state.blogCategories.length > 0) {
      return this.state.blogCategories.map((category, i) => {
        return (
          <LinkContainer key={i} style={{marginRight:5, marginBottom:5}} to={`../../../../blog/${encodeURIComponent(category.categorySlug)}`}>
            <Button bsSize="xsmall">
              {category.categoryTitle}
            </Button>
          </LinkContainer>
        );
      });
    }
  }
  renderBlogTags() {
    if (this.state.blogTags.length > 0) {
      if (this.state.blogTagsCount) {
        return this.state.blogTags.map((tag, i) => {
          if (this.state.blogTagsCount.hasOwnProperty(tag)) {
            return (
              <LinkContainer key={i} style={{marginRight:5, marginBottom:5}} to={`../../../../blog/tag/${encodeURIComponent(tag)}`}>
                <Button bsSize="xsmall">
                  {tag} ({this.state.blogTagsCount[tag]})
                </Button>
              </LinkContainer>
            )
          }
          return false;
        });
      }
    }
  }
  modalClose = () => {this.setState({showModal: false});};
  render() {
    return (
      <div>
        {this.state.blogCategories.length > 0 && <h4 style={{marginTop:0}}>Blog Categories:</h4>}
        {this.renderCategories()}
        {this.state.blogTags.length > 0 && this.state.blogTagsCount && <h4 style={{marginTop:5}}>Blog Tags:</h4>}
        {this.renderBlogTags()}
        <Modal show={this.state.showModal} onHide={this.modalClose}>
          <Modal.Header bsClass={this.state.bsClass} closeButton>
            {this.state.bsClass === 'modal-header modal-header-danger' && <i className="fa fa-warning fa-fw" aria-hidden="true"/>} {this.state.modalTitle}
          </Modal.Header>
          <Modal.Body>
            {this.state.modalMessage}
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Blog/TagsList.js